export default "__VITE_ASSET__B4Yqi7xM__"